<template>
  <div>
    <div class="home">
      <Navbar/>

      <div class="d-flex justify-content-center">
        <div class="home__box">
          <div id="block-about" class="home__box-wrapper">
            <About/>
          </div>

          <div id="block-soundlab" class="home__box-wrapper">
            <Soundlab/>
          </div>

          <div id="block-video" class="home__box-wrapper">
            <Media/>
          </div>

          <div id="block-contact" class="home__box-wrapper">
            <Contact/>
          </div>

        </div>
      </div>

      <Footer/>

    </div>

    <div class="home-mobile">
      <div class="d-flex justify-content-center">
        <div class="mobile__box">
          <div id="block-about-mobile" class="blockmobile">
            <MobileAbout/>
          </div>

          <div id="block-soundlab-mobile" class="blockmobile">
            <MobileSoundlab/>
          </div>

          <div id="block-video-mobile" class="blockmobile">
            <MobileMedia/>
          </div>

          <div id="block-contact-mobile" class="blockmobile" >
            <MobileContact/>
          </div>
        </div>
      </div>

      <NavbarMobile />
    </div>
  </div>

</template>

<script>
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import About from "../blocks/About";
import Soundlab from "../blocks/Soundlab";
// import Playlist from "../blocks/Playlist";
import Contact from "../blocks/Contact";
import Welcome from "../components/Welcome";
import NavbarMobile from "../components/NavbarMobile";
import Media from "../blocks/Media";
import MobileAbout from "../mobile/MobileAbout";
import MobileSoundlab from "../mobile/MobileSoundlab";
// import MobilePlaylist from "../mobile/MobilePlaylist";
import MobileMedia from "../mobile/MobileMedia";
import MobileContact from "../mobile/MobileContact";

export default {
  name: 'Home',
  components: {
    Footer,
    Navbar,
    About,
    Soundlab,
    Contact,
    Welcome,
    NavbarMobile,
    Media,
    MobileAbout,
    MobileSoundlab,
    MobileMedia,
    MobileContact
  },
  computed: {
    percentage: function () {
      return this.$store.getters.scrollPercentage;
    }
  },
  methods: {
    onScroll() {
      let scrollPercent =
          (document.body.scrollTop + document.documentElement.scrollTop) /
          (document.documentElement.scrollHeight - document.documentElement.clientHeight);
      this.$store.commit('setScrollPercentage', scrollPercent);
    },
  },
  mounted() {
    document.addEventListener("scroll", this.onScroll);
  }
}
</script>

<style>
.mobile__box .blockmobile{
  margin-bottom: 60px;
}
.mobile__box{
  /*background-color: greenyellow;*/
  background-color: #F1F1F1;
  width: 90%;
  /*height: 100vh;*/
  margin-top: 80px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;

}

.home__box .home__box-wrapper{
  padding-top: 4vh;
  /*height: 120vh !important;*/
}
@media screen and (max-width: 1024px) {
  .home {
    display: none;
  }

  .home-mobile {
    display: block;
  }
}

@media screen and (min-width: 1024px) {
  .home {
    display: block;
  }

  .home-mobile {
    display: none;
  }
}

.home__box {
  width: 1200px;
  /*height: 500vh;*/
  margin-top: 170px;
  background-color: #f6f6f6;
}

.home {
  height: 200vh;
  width: 100%;
}
</style>
